import { render } from "./TransfersPerCurrencyCard.vue?vue&type=template&id=5b9fdaa6&scoped=true"
import script from "./TransfersPerCurrencyCard.vue?vue&type=script&lang=js"
export * from "./TransfersPerCurrencyCard.vue?vue&type=script&lang=js"

import "./TransfersPerCurrencyCard.vue?vue&type=style&index=0&id=5b9fdaa6&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9fdaa6"],['__file',"src/components/TransfersPerCurrencyCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b9fdaa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b9fdaa6', __exports__)) {
    console.log('reload')
    api.reload('5b9fdaa6', __exports__)
  }
  
  module.hot.accept("./TransfersPerCurrencyCard.vue?vue&type=template&id=5b9fdaa6&scoped=true", () => {
    console.log('re-render')
    api.rerender('5b9fdaa6', render)
  })

}


export default __exports__